import { Container, Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import React from 'react'

import ImageBlock from '@/components/imageBlock'
import { getFlightLogoUrl } from '@/utils/images'

const MultiAirlineLogo = ({ data = [] }) => {

    if (data?.length > 2) return <>
        <Container className={'flex flex-gap-1'} >
            <ImageBlock
                altText={data[0]?.airlineCode || 'multiple airline'}
                customClass={'br-2 o-hidden'}
                height={32}
                path={getFlightLogoUrl(data[0]?.airlineCode)}
                width={32}
            />
            <Container className='p-relative'>
                <Image
                    alt={'multiple airline'}
                    className={'br-2 o-hidden'}
                    height={32}
                    src={"https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/MultiairlineBaseImage.png"}
                    width={32}
                />
                <Typography className='p-absolute' style={{ top: 6, right: 8, color: '#808080' }} variant='B2'>
                    {`+${data?.length - 1}`}
                </Typography>
            </Container>
        </Container>
    </>
    return (
        <Container className='flex'>
            {data?.map((item: any, index: number) => {
                return (
                    <Container
                        key={index}
                        className={index > 0 ? 'ml-1' : ''}
                        style={{ height: '32px', width: '32px' }}
                    >
                        <ImageBlock
                            altText={item?.airlineCode}
                            customClass={'br-2 o-hidden'}
                            height={32}
                            path={getFlightLogoUrl(item?.airlineCode)}
                            width={32}
                        />
                    </Container>
                )
            })}
        </Container>
    )
}

export default MultiAirlineLogo
